function calcProgressAngle(progress) {
  if (!progress) return null
  const proporcion = 90 / 25
  const angle = progress * proporcion + 90
  /* TO REPRESENT FROM 0% TO 50% WE MOVE IT FROM 90deg, 180deg, to 270dec the first gradient */
  /* TO REPRESENT FROM 50% TO 100% WE MOVE IT FROM 270deg, 360deg, to 90deg the second gradient */
  // IN THE SECOND GRADIENT 450deg it's similar to 90deg
  return angle
}

export default calcProgressAngle
